module.exports = __webpack_public_path__ + "img/recorrente.3f4a70f5.png";